import cn from "classnames";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import Link from "next/link";
import styles from "./styles.module.scss";
import BreadCrumb from "../../components/Shared/BreadCrumb";

export const Banner = ({
  className,
  title,
  content,
  image,
  breadcrumb_title,
  secondary_breadcrumb_url,
  secondary_breadcrumb_title,
  // returnLinkURL,
  // returnLinkTitle,
  buttonLink,
  buttonTitle,
  buttonNewTab,
  buttons = [],
  buttonLayout = "horizontal",
  heading,
}) => {
  const buttonContainerClasses =
    buttonLayout === "vertical"
      ? "d-flex flex-column align-items-start gap-3 mt-4"
      : "d-flex flex-wrap align-items-center gap-3 mt-4";

  return (
    <section className={cn(styles.root, className, "position-relative")}>
      <Container>
        <Row className="m-0 justify-content-between">
          <Col
            lg={6}
            className="contentWrapper d-flex flex-wrap align-items-center position-relative"
          >
            <div className={`position-relative wrapper mb-4 w-100`}>
              {breadcrumb_title && (
                <BreadCrumb
                  title={
                    <>
                      {secondary_breadcrumb_url && (
                        <span>
                          <Link href={secondary_breadcrumb_url}>
                            <a>{secondary_breadcrumb_title}</a>
                          </Link>
                        </span>
                      )}

                      <span className="active">{breadcrumb_title}</span>
                    </>
                  }
                  className={`py-2`}
                />
              )}
            </div>
            <div>
              {/* {returnLinkURL && (
                <Link href={returnLinkURL}>
                  <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4">
                    <strong>{returnLinkTitle}</strong>
                  </a>
                </Link>
              )} */}
              {title && <h1 className={cn(styles.title, heading, 'fw-bold')}>{title}</h1>}
              {content && (
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}

              {buttons && buttons.length > 0 ? (
                <div className={buttonContainerClasses}>
                  {buttons.map((button, index) => {
                    const isLink =
                      button.variant === "secondaryLink" ||
                      button.variant === "secondaryLinkWhite";
                    const finalButtonClass = `${
                      button.variant || "primaryBtn"
                    } ${!isLink ? "no-arrow" : ""} m-0`;

                    return (
                      <Link href={button.href || "#"} key={`button-${index}`}>
                        <a
                          className={finalButtonClass}
                          target={button.newTab ? "_blank" : "_self"}
                          rel={
                            button.newTab ? "noopener noreferrer" : undefined
                          }
                        >
                          {button.label}
                        </a>
                      </Link>
                    );
                  })}
                </div>
              ) : buttonLink && buttonTitle ? (
                <div className="mt-4">
                  <a
                    href={buttonLink}
                    className="primaryBtn no-arrow m-0 outline"
                    target={buttonNewTab ? "_blank" : "_self"}
                  >
                    {buttonTitle}
                  </a>
                </div>
              ) : null}
            </div>
          </Col>
          <div className="imageWrapper position-absolute p-0">
            <SourceFlowImage
              src={image?.url ? image.url : "/site-assets/images/banner.webp"}
              size="2000x"
              alt={image?.alt ? image.alt : title}
              className="card-img rounded-0"
              loading="eager"
            />
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
